import Link from '@amzn/awsui-components-react/polaris/link';
import { HelpPanel, Popover } from '@amzn/awsui-components-react';
import React from 'react';
import Button from '@amzn/awsui-components-react/polaris/button';
import { useLocalizedText } from '../../../../hooks/localizedText';
import { LocalizedTrans } from '../../../../hooks/localization/localizedTrans';

const GIVEHUB_SEARCH_URL = 'https://amazon.benevity.org/causes/search/';
const NOMINATE_CAUSE_URL = 'https://amazon.benevity.org/nominate-cause';

function CommunityOrgHelpTranslation() {
  const namespaces = ['events', 'translation'];
  const { t } = useLocalizedText(namespaces);

  // Structural markup (headings, list, paragraph breaks) lives in JSX; only inline tags
  // (<link>, <b>) stay in the message, since intl-messageformat has no self-closing tags.
  // Each linked segment names its tag `link` and supplies its own single-entry map, so the
  // two different destinations no longer need the legacy link1/link2 split.
  return (
    <>
      <p>{t('eventDetailsStep.communityOrganizationInfo.intro')}</p>
      <h3>{t('eventDetailsStep.communityOrganizationInfo.tipsHeading')}</h3>
      <ul>
        <li>{t('eventDetailsStep.communityOrganizationInfo.tip1')}</li>
        <li>{t('eventDetailsStep.communityOrganizationInfo.tip2')}</li>
        <li>{t('eventDetailsStep.communityOrganizationInfo.tip3')}</li>
      </ul>
      <h3>{t('eventDetailsStep.communityOrganizationInfo.cantFindHeading')}</h3>
      <p>
        <LocalizedTrans
          i18nKey="events:eventDetailsStep.communityOrganizationInfo.cantFindBody"
          components={{
            link: <Link external href={GIVEHUB_SEARCH_URL} target="_blank" />,
          }}
        />
      </p>
      <h3>{t('eventDetailsStep.communityOrganizationInfo.notListedHeading')}</h3>
      <p>{t('eventDetailsStep.communityOrganizationInfo.notListedBody')}</p>
      <p>
        <LocalizedTrans
          i18nKey="events:eventDetailsStep.communityOrganizationInfo.nominate"
          components={{
            link: <Link external href={NOMINATE_CAUSE_URL} target="_blank" />,
          }}
        />
      </p>
      <p>
        <LocalizedTrans
          i18nKey="events:eventDetailsStep.communityOrganizationInfo.note"
          components={{ b: <b /> }}
        />
      </p>
    </>
  );
}

export function CommunityOrganizationHelpPanel() {
  const namespaces = ['events', 'translation'];
  const { t } = useLocalizedText(namespaces);

  return (
    <HelpPanel
      data-testid="comm-org-help-panel"
      header={<h2>{t('eventDetailsStep.communityOrganization')}</h2>}
    >
      <CommunityOrgHelpTranslation />
    </HelpPanel>
  );
}

export function CommunityOrganizationHelpPopover() {
  const namespaces = ['events', 'translation'];
  const { t } = useLocalizedText(namespaces);

  return (
    <Popover
      data-testid="comm-org-help-popover"
      size="large"
      triggerType="custom"
      content={<CommunityOrgHelpTranslation />}
      header={t('eventDetailsStep.communityOrganization')}
      dismissAriaLabel={t('misc.close')}
    >
      <Button
        variant="inline-link"
        ariaLabel={t('eventDetailsStep.communityOrganizationInfoAriaLabel')}
      >
        {t('misc.info')}
      </Button>
    </Popover>
  );
}
